module.exports = __webpack_public_path__ + "static/media/close.31fd6118.svg";